import { render, staticRenderFns } from "./RentManageDetail.vue?vue&type=template&id=bf95b386&scoped=true"
import script from "./RentManageDetail.vue?vue&type=script&lang=js"
export * from "./RentManageDetail.vue?vue&type=script&lang=js"
import style0 from "./RentManageDetail.vue?vue&type=style&index=0&id=bf95b386&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf95b386",
  null
  
)

export default component.exports